import {
  UNITED_STATES_NAMES,
  US_UK_CANADA_COUNTRY_GROUP,
  US_CANADA_COUNTRY_GROUP
} from '../constants'

/**
 * Determines if location array does not contain United States
 * @param {Array<string>} locationArray an array of locations
 * @returns {boolean}
 * @example
 * locationListIsInternational(['Canada']) // true
 * locationListIsInternational(['New York', 'United States']) // false
 */
export function locationListIsInternational(
  locationArray: string[] = []
): boolean {
  return !locationArray.some((part) => UNITED_STATES_NAMES.has(part))
}

/**
 * Determines if United States, UK, or Canada exist in the location array
 * @param {Array<string>} locationArray an array of locations
 * @returns {boolean}
 * @example
 * locationListHasUsOrUkOrCanada(['Austrailia']) // false
 * locationListHasUsOrUkOrCanada(['Canada']) // true
 * locationListHasUsOrUkOrCanada(['New York', 'United States']) // true
 * locationListHasUsOrUkOrCanada(['London', 'United Kingdom']) // true
 */
export function locationListHasUsOrUkOrCanada(
  locationArray: string[] = []
): boolean {
  return locationArray.some((part) => US_UK_CANADA_COUNTRY_GROUP.has(part))
}

/**
 * Determines if United States or Canada exist in the location array
 * @param {Array<string>} locationArray an array of locations
 * @returns {boolean}
 * @example
 * locationListHasUsOrCanada(['Mexico']) // false
 * locationListHasUsOrCanada(['Canada']) // true
 * locationListHasUsOrCanada(['New York', 'United States']) // true
 */
export function locationListHasUsOrCanada(
  locationArray: string[] = []
): boolean {
  return locationArray.some((part) => US_CANADA_COUNTRY_GROUP.has(part))
}
